import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { AuthService } from "angularx-social-login";
import { GoogleLoginProvider } from "angularx-social-login";
import { SubscriptionService } from "../subscription/subscription.service";

@Component({
  selector: 'app-enterprise',
  templateUrl: './enterprise.component.html',
  styleUrls: ['./enterprise.component.css']
})
export class EnterpriseComponent implements OnInit {

  currentUser: User;
  strikeCheckout:any = null;
  selectedMembership: any = null;

  loginStyle = "none";
  detailsYearly: boolean = true;
  mobileView: boolean = false;
  workspace_token: string;
  currentValue: string

  address: string = '124 santa rosa';
  city: string = 'San Francisco';
  state: string = 'CA';
  country: string = 'US';
  postcode: string = '94014';
  newAmount: string;
  totalUsers: string;
  isCustomPlan: boolean = false;

  public lat;
  public lng;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private subscriptionService: SubscriptionService,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.authService.authState.subscribe((user) => {
      if (user && !this.authenticationService.currentUserValue) {
        this.loginToServer(user, user.photoUrl, this.workspace_token);
      }
    });

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) {
      this.mobileView = true;
    }else{
      this.mobileView = false;
    }

    if (this.currentUser) {
      this.currentValue = "Logout";
    }else{
      this.currentValue = "Login";
    }
    this.getLocation();
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
        }
      },
        (error: PositionError) => console.log(error));
    } else {
      // alert("Geolocation is not supported by this browser.");
    }
  }

  openLogin(amount, currency, id){
    if (this.currentUser) {
      this.checkoutStripe(amount, currency, id);
    }else{
      this.openLoginDialog();
    }
  }

  openLoginDialog(){
    this.loginStyle = "block";
  }

  closeLoginDialog(){
    this.loginStyle = "none";
  }

  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID)
  }

  loginToServer(user: any = null, photoUrl: string, workspace_token: string) {
    this.authenticationService.login(user.provider.toLowerCase(), user.id,
    user.authToken, user.email, user.firstName, user.lastName,
    photoUrl, this.lat, this.lng, workspace_token)
      .subscribe(
        (_data) => {
          this.closeLoginDialog();
          this.currentValue = "Logout";
        }
      );
  }

  loginLogout(){
    if (this.currentUser) {
      this.authenticationService.logoutCompany();
      this.authService.signOut();
      this.currentValue = "Login";
    }else{
      this.loginStyle = "block";
    }
  }

  checkoutStripe(amount: any, currency: any, id: any) {
    const strikeCheckout = (<any>window).StripeCheckout.configure({
      key: environment.STRIPE_LIVE_KEY,
      locale: 'auto',
      token: (stripeToken: any) => {
        // console.log(stripeToken)
        this.subscriptionService.postStripeOrder(stripeToken, amount, currency, id,
          this.currentUser.firstName+" "+ this.currentUser.lastName, this.address,
          this.city, this.state, this.country, this.postcode,
          this.newAmount, this.totalUsers, this.isCustomPlan, "").subscribe((data) => {
          // this.showSuccess();
        });
      }
    });

    strikeCheckout.open({
      name: 'Crafttor',
      description: 'Stripe Payment Gateway',
      image: 'https://crafttor.com/crafttor.jpg',
      currency: currency,
      amount: amount * 100
    });
  }

stripePaymentGateway() {
  if(!window.document.getElementById('stripe-script')) {
    const scr = window.document.createElement("script");
    scr.id = "stripe-script";
    scr.type = "text/javascript";
    scr.src = "https://checkout.stripe.com/checkout.js";

    scr.onload = () => {
      this.strikeCheckout = (<any>window).StripeCheckout.configure({
        key: environment.STRIPE_LIVE_KEY,
        locale: 'auto',
        token: function (token: any) {
        console.log(token)
        alert('Payment via stripe successfull!');
        }
      });
    }
    window.document.body.appendChild(scr);
    }
  }

  goToMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }
}
